module.exports = __webpack_public_path__ + "icon_tel.png?d6e14e89cf7e7738603416706a8ad180";


//////////////////
// WEBPACK FOOTER
// ./static/assets/icon_tel.png
// module id = 202
// module chunks = 0